import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const MockupDisplayCard = ({ mockup, isSelected, onSelect }) => {
  console.log("MockupDisplayCard: received mockup prop:", mockup);
  const [displayImage, setDisplayImage] = useState(mockup.mockup_image_url); // Start with mockup image
  const [isMockupView, setIsMockupView] = useState(true); // True for mockup, false for original
  const navigate = useNavigate();

  const toggleImage = () => {
    if (isMockupView) {
      setDisplayImage(mockup.original_image_url);
    } else {
      setDisplayImage(mockup.mockup_image_url);
    }
    setIsMockupView(!isMockupView);
  };

  const handleSendToPrint = () => {
    navigate(`/review-mockup/${mockup.id}`);
  };

  return (
    <div
      className={`bg-white rounded-lg shadow-lg p-6 flex flex-col transition-all duration-300 hover:shadow-xl cursor-pointer ${
        isSelected ? 'ring-4 ring-blue-500' : ''
      }`}
      onClick={() => onSelect(mockup.id)}
    >
      <div className="relative w-full pb-[100%] bg-gray-100 rounded-md overflow-hidden mb-4 flex items-center justify-center">
        <img
          src={displayImage}
          alt={isMockupView ? "Generated Mockup" : "Original Image"}
          className="absolute inset-0 w-full h-full object-contain transition-transform duration-300 hover:scale-105"
        />
        <div className="absolute inset-0 flex items-center justify-between p-4">
          <button onClick={toggleImage} className="bg-black bg-opacity-50 text-white rounded-full p-2">
            &lt;
          </button>
          <button onClick={toggleImage} className="bg-black bg-opacity-50 text-white rounded-full p-2">
            &gt;
          </button>
        </div>
      </div>
      <p className="text-gray-800 font-semibold mb-1">Prompt: {mockup.prompt}</p>
      <p className="text-gray-600 text-sm mb-2">T-shirt Model: {mockup.tshirt_model_name}</p>
      <p className="text-gray-600 text-sm mb-2">Variant: {mockup.tshirt_variant_id}</p>
      {mockup.image_placement && <p className="text-gray-600 text-sm mb-2">Placement: {mockup.image_placement}</p>}
      {mockup.stitch_color && <p className="text-gray-600 text-sm mb-2">Stitch Color: {mockup.stitch_color}</p>}
      <p className="text-gray-600 text-sm mb-4">Style: {mockup.style}</p>
      <p className="text-gray-800 font-bold mb-4">Price: ${mockup.price ? mockup.price.toFixed(2) : 'N/A'}</p>

      <button
        onClick={handleSendToPrint}
        className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-md transition-colors"
      >
        Proceed to Payment
      </button>
    </div>
  );
};

export default MockupDisplayCard;